import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";
import type {Role} from "@khan/auth-shared";
import {useLocation} from "@khan/urls";

const roleMap: Record<Role, "TEACHER" | "STUDENT" | "PARENT"> = {
    learner: "STUDENT",
    teacher: "TEACHER",
    parent: "PARENT",
};

/**
 * An event to track that the Extra Info page form was submitted, and by what
 * type of user.
 */
export function usePublishExtraInfoSubmittedEvent() {
    const location = useLocation();
    const publishAnalyticsEvent = usePublishAnalyticsEvent();

    return function (role: Role): Promise<Response | void> {
        return publishAnalyticsEvent({
            eventType: "SignUpExtraInfoSubmitted",
            eventSchemaVersion: 1,
            currentPageUrlPath: location.pathname,
            role: roleMap[role],
        });
    };
}
